import type { DocPageContent } from '../docs-content'

const page = {
  order: 17,
  slug: 'local-ai',
  title: '本地 AI 工具',
  description: '浏览器端 AI 模型、文本转语音、音乐生成、缓存和卸载。',
  category: '创意工具',
  sections: [
    {
      title: '本地 AI 的工作原理',
      items: [
        '当所需的 API 和硬件支持可用时，本地 AI 在浏览器中运行。',
        '首次下载模型可能较大，之后会缓存在本地。',
        '本地 AI 状态指示器显示加载中、运行中、就绪和错误状态。',
      ],
    },
    {
      title: '生成工具',
      items: [
        '使用"文本转语音"从文本合成语音并插入链接的音频。',
        '在可用时选择支持的 TTS 引擎、语言、声音、表达标签和速度。',
        '使用"音乐生成"配合描述流派、情绪、节奏和乐器的提示词。',
        '将生成的音乐保存到媒体库或插入时间线。',
      ],
    },
    {
      title: '缓存与运行时控制',
      items: [
        '使用"本地 AI 模型缓存"检查或清除缓存的下载内容。',
        '使用"卸载本地模型"释放驻留运行时。',
        '当不再需要结果时取消长时间运行的任务。',
      ],
    },
  ],
} satisfies DocPageContent

export default page